import React from 'react'
import CompanyName from './Component/CompanyName'
import { Button } from '@mui/material'
import PhoneIcon from '@mui/icons-material/Phone';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';


const theme = createTheme({
  palette: {
    primary: {
      main: "#99aab5", // custom primary color
    },
    secondary: {
      main: "#F27920", // custom secondary color
    },
  },
});

export default function Contact() {
  return (
    <div className='p-20 container mx-auto bg-white my-20'>
      <article>
        <section>
          <div className='pb-5'>
            <h1 className='text-2xl font-bold text-[#F27920]'><CompanyName /></h1>
          </div>
          <p>
            11911 US Highway 1, Suite 309, North Palm Beach, FL 33408
          </p>
        </section>


        <section className='lg:flex my-10'>
          <div className='lg:w-1/12'>Tel:</div>
          <div className='lg:w-11/12'>
            <ThemeProvider theme={theme}><Button color="secondary" variant="contained" style={{ color: '#ffffff' }} fullWidth startIcon={<PhoneIcon />}><Link href='tel:9543519333' style={{ color: '#ffffff' }}>954-351-9333</Link></Button></ThemeProvider>
          </div>
        </section>

        <section className='lg:flex my-10'>
          <div className='lg:w-1/12'>E-mail:</div>
          <div className='lg:w-11/12'>
            <ThemeProvider theme={theme}><Button color="secondary" variant="contained" fullWidth startIcon={<EmailIcon />} style={{ wordBreak: 'break-all', textTransform: 'lowercase', color: '#ffffff' }}><Link href='mailto:Info@savetheseaturtle.org' style={{ color: '#ffffff' }}>Info@savetheseaturtle.org</Link></Button></ThemeProvider>
          </div>
        </section>


      </article>
    </div >
  )
}
